import WidgetCommonContainer, {
  WidgetCommonFTUContainer,
} from "@/components/widgets/WidgetCommonContainer"
import BottomIcon from "@/assets/clipart/widgets/loans-bottom-icon.svg"
import { useLoans } from "@/queries/loan"
import { WidgetWrapper } from "./WidgetWrapper"
import { router } from "expo-router"

import * as HomeEvents from "@/analytics/events/home"

export default function LoansWidget() {
  const { data: loans } = useLoans("", null)

  const loanCount = loans?.pages[0]?.loanApplications?.length || 0
  const hasLoans: boolean = loanCount > 0
  // To test....
  // const hasLoans: boolean = false

  const ctaText = hasLoans
    ? "Check loan\nstatus"
    : `Find a loan\nproduct that\nworks for YOU`

  const onPress = () => {
    HomeEvents.homepageWidgetClicked({
      nextScreen: "Loan Property Search",
      widgetType: "widget-loans",
      widgetTitle: "Loans",
      widgetState: hasLoans ? "non-zero-value" : "zero-value",
      widgetCta: ctaText,
      widgetValue: hasLoans ? loanCount.toString() : undefined,
    })
    router.push("/loans/")
  }

  return (
    <WidgetWrapper
      title="Loans"
      category="loans"
      orientation="vertical"
      onPress={onPress}
    >
      {!hasLoans ? (
        <WidgetCommonFTUContainer
          headerText={ctaText}
          BottomIconComponent={BottomIcon}
        />
      ) : (
        <WidgetCommonContainer
          headerCount={loanCount.toString()}
          subTitle={"Applications"}
          ctaText={ctaText}
        />
      )}
    </WidgetWrapper>
  )
}
